/**
 * The responsbility of this component is to render a Google Embed map when it is called.
 * It uses the google maps api key from the environment variables.
 * It uses an iframe to embed the map and loads it lazily.
 * The map is centered at a specific location (latitude: 21.17, longitude: 72.83) with a zoom level of 12.
 * The component is memoized to prevent unnecessary re-renders.
 * The styles for the map container and iframe are defined in the component itself.
 */

import React from 'react';
import { SURAT_CENTER } from '../../../app/store/constant';

function EmbedMap() {
    const zoomLevel = 12;
    const mapMode = 'view';
    const embedMapUrl = `https://www.google.com/maps/embed/v1/${mapMode}?zoom=${zoomLevel}&center=${SURAT_CENTER.lat}%2C${SURAT_CENTER.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

    return (
        <div style={embedMapContainerStyles}>
            <iframe loading="lazy" src={embedMapUrl} style={embedMapStyles} />
        </div>
    );
}

export default React.memo(EmbedMap);

const embedMapContainerStyles = {
    width: '515px',
    height: '316px',
    overflow: 'hidden'
};

const embedMapStyles = {
    width: '100%',
    height: '100%',
    border: 0,
    borderRadius: '1rem'
};
